import { QueryClient } from "@tanstack/react-query";

/**
 * Shared across the app so that code running outside React (route loaders, plain async
 * helpers) can read the same cache the components use.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0, refetchOnWindowFocus: false } },
});
